/**
 * @generated SignedSource<<6718298d055bb8118877bc2d930a4b0a>>
 * @relayHash 054ff1d044a88d72c8190c4e95486551
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID d76d2d503320e36d09076652b2b41d61cb81839e0eedd2aa0b959bf242a17b03

import type { ConcreteRequest } from 'relay-runtime';
export type SignInvocationTokenForUIInput = {
  forgeContextToken: string;
  remoteKey: string;
};
export type useRemoteFetchClient_signInvocationTokenForUIMutation$variables = {
  input: SignInvocationTokenForUIInput;
};
export type useRemoteFetchClient_signInvocationTokenForUIMutation$data = {
  readonly signInvocationTokenForUI: {
    readonly errors: ReadonlyArray<{
      readonly extensions: {
        readonly errorType: string | null | undefined;
        readonly statusCode: number | null | undefined;
      } | null | undefined;
      readonly message: string | null | undefined;
    }> | null | undefined;
    readonly forgeInvocationToken: {
      readonly jwt: string;
    } | null | undefined;
    readonly metadata: {
      readonly baseUrl: string;
    } | null | undefined;
    readonly success: boolean;
  } | null | undefined;
};
export type useRemoteFetchClient_signInvocationTokenForUIMutation = {
  response: useRemoteFetchClient_signInvocationTokenForUIMutation$data;
  variables: useRemoteFetchClient_signInvocationTokenForUIMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "success"
},
v3 = {
  "kind": "ScalarField",
  "name": "statusCode"
},
v4 = {
  "kind": "ScalarField",
  "name": "errorType"
},
v5 = {
  "kind": "ScalarField",
  "name": "message"
},
v6 = {
  "concreteType": "ForgeInvocationToken",
  "kind": "LinkedField",
  "name": "forgeInvocationToken",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "jwt"
    }
  ]
},
v7 = {
  "concreteType": "InvocationTokenForUIMetadata",
  "kind": "LinkedField",
  "name": "metadata",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "baseUrl"
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useRemoteFetchClient_signInvocationTokenForUIMutation",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "SignInvocationTokenForUIResponse",
        "kind": "LinkedField",
        "name": "signInvocationTokenForUI",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "concreteType": "MutationError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/)
                ]
              },
              (v5/*: any*/)
            ]
          },
          (v6/*: any*/),
          (v7/*: any*/)
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useRemoteFetchClient_signInvocationTokenForUIMutation",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "SignInvocationTokenForUIResponse",
        "kind": "LinkedField",
        "name": "signInvocationTokenForUI",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "concreteType": "MutationError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "__typename"
                  },
                  (v3/*: any*/),
                  (v4/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "id"
                      }
                    ],
                    "type": "BulkMutationErrorExtension"
                  }
                ]
              },
              (v5/*: any*/)
            ]
          },
          (v6/*: any*/),
          (v7/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "id": "d76d2d503320e36d09076652b2b41d61cb81839e0eedd2aa0b959bf242a17b03",
    "metadata": {},
    "name": "useRemoteFetchClient_signInvocationTokenForUIMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "fe7d32870ddf9b8f5524abb29f382040";

export default node;
